import React, { useCallback, useEffect, useMemo, useState } from "react";
import { CiSettings } from "react-icons/ci";
import { toast } from "react-toastify";
import DataTable from "../components/DataTable";
import Layout from "../components/Layout";
import Modal from "../components/Modal";
import ParameterButtons from "../components/ParameterButtons";
import { grids } from "../constants/grids";
import { useLazyGetFieldsByFormQuery } from "../redux/formService";
import {
  useLazyGetParamsQuery,
  usePostParamMutation,
  useUpdateParamMutation,
} from "../redux/paramService";
import { filterDataByDate } from "../utils";
import Pagination from "../components/Pagination";

const GestionAdresses = () => {
  const [showForm, setShowForm] = useState(false);
  const [filter, setFilter] = useState();
  const [selectedParams, setSelectedParams] = useState();
  const [showTable, setShowTable] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedGrid, setSelectedGrid] = useState();
  const [fields, setFields] = useState([]);
  const [villes, setVilles] = useState([]);
  const [communes, setCommunes] = useState([]);
  const [data, setData] = useState();

  const [getFields] = useLazyGetFieldsByFormQuery();
  const [getParams, { data: paramsData, isLoading: isLoadingParams }] =
    useLazyGetParamsQuery();
  const [postParams] = usePostParamMutation();
  const [updateParams] = useUpdateParamMutation();
  const handleShowModal = useCallback((props) => {
    setSelected({ id: props?.id, ...props?.attributes });
    setShowForm(true);
  }, []);

    const [fetchedPage, setFetchedPage] = useState({ page: 1, size: 10 });
  
  const fetchData = async (endpoint) => {
    const result = [];
    const response = await getParams({ endpoint, page: 1, size: 100 });
    response?.data?.data?.forEach((item) => {
      if (item.attributes.name) {
        result.push({ label: item.attributes.name, value: item.id });
      }
    });
    return result;
  };

  const next = useCallback(() => {
    const endpointMap = {
      ville: "villes",
      commune: "communes",
      quartier: "quartiers",
    };
  
    const endpoint = endpointMap[selectedParams];
    if (!endpoint) return;
  
    setFetchedPage((prev) => {
      const nextPage = prev.page + 1;
      // Charger les données après avoir mis à jour la page
      getParams({ endpoint, page: nextPage, size: prev.size }).then((res) => {
        setData(res.data?.data);
      });
      return { ...prev, page: nextPage };
    });
  }, [getParams, selectedParams]);
  
  const prev = useCallback(() => {
    const endpointMap = {
      ville: "villes",
      commune: "communes",
      quartier: "quartiers",
    };
  
    const endpoint = endpointMap[selectedParams];
    if (!endpoint) return;
  
    setFetchedPage((prev) => {
      const prevPage = prev.page > 1 ? prev.page - 1 : 1;
      getParams({ endpoint, page: prevPage, size: prev.size }).then((res) => {
        setData(res.data?.data);
      });
      return { ...prev, page: prevPage };
    });
  }, [getParams, selectedParams]);

  const selectParameter = async (e) => {
    setSelectedParams(e);
    setShowTable(false);

    const endpoint = grids[e]?.endpoint;
    const grid = grids[e]?.grid;

    if (!endpoint || !grid) return;

    let fetchedFields = [];
    let fetchedVilles = [];
    let fetchedCommunes = [];
    let fetchedQuartier = [];

    if (e === "ville") {
      fetchedVilles = await fetchData("villes");
      setData(
        await getParams({ endpoint: "villes", page: fetchedPage.page, size: fetchedPage.size }).then(
          (res) => res.data?.data
        )
      );
      fetchedFields = await getFields(23).then((res) => res.data?.data || []);
    }

    if (e === "commune") {
      fetchedVilles = await fetchData("villes");
      fetchedCommunes = await fetchData("communes");
      setData(
        await getParams({ endpoint: "communes", page: fetchedPage.page, size: fetchedPage.size}).then(
          (res) => res.data?.data
        )
      );
      fetchedFields = await getFields(22).then((res) => res.data?.data || []);
      fetchedFields = fetchedFields.map((field) => {
        if (field.attributes.field_id === "ville") {
          return {
            ...field,
            attributes: {
              ...field.attributes,
              options: fetchedVilles,
            },
          };
        }
        return field;
      });
    }

    if (e === "quartier") {
      fetchedCommunes = await fetchData("communes");
      fetchedVilles = await fetchData("villes");
      fetchedQuartier = await fetchData("quartiers");
      setData(
        await getParams({ endpoint: "quartiers", page: fetchedPage.page, size: fetchedPage.size }).then(
          (res) => res.data?.data
        )
      );
      fetchedFields = await getFields(21).then((res) => res.data?.data || []);
      fetchedFields = fetchedFields.map((field) => {
        if (field.attributes.field_id === "commune") {
          return {
            ...field,
            attributes: {
              ...field.attributes,
              options: fetchedCommunes,
            },
          };
        }
        if (field.attributes.field_id === "ville") {
          return {
            ...field,
            attributes: {
              ...field.attributes,
              options: fetchedVilles,
            },
          };
        }
        return field;
      });
    }

    setFields(fetchedFields);
    setVilles(fetchedVilles);
    setCommunes(fetchedCommunes);
    setSelectedGrid(grid);

    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const sendData = async (data) => {
    const endpointMap = {
      ville: "villes",
      commune: "communes",
      quartier: "quartiers",
    };

    const endpoint = endpointMap[selectedParams];
    data.endpoint = endpoint;

    console.log("selected", selected);

    const action = selected
      ? updateParams({ ...data, endpoint })
      : postParams(data);

    action
      .then(async () => {
        setShowForm(false);
    
          await getParams({ endpoint, page: 1, size: 100 }).then(
            (res) =>     setData( res.data?.data)
          )
        setSelected(null);
        toast.success(
          selected ? "Mise à jour réussie" : "Ajout du type réussie"
        );
      })
      .catch(() =>
        toast.error(
          selected
            ? "Une erreur s'est produite pendant la mise à jour"
            : "Une erreur s'est produite, veuillez réessayer"
        )
      );
  };

  const filteredData = useMemo(
    () => filterDataByDate(paramsData, filter),
    [paramsData, filter]
  );

  useEffect(() => {
    const fetchInitialData = async () => {
      setVilles(await fetchData("villes"));
      setCommunes(await fetchData("communes"));
    };
    fetchInitialData();
  }, []);

  return (
    <Layout title="Gestion des adresses">
      <div className="w-full flex flex-col items-center">
        {console.log("le data", data)}
        <Modal
          showForm={showForm}
          send={sendData}
          setShowForm={setShowForm}
          fields={fields}
          selectedData={selected}
        />
        <ParameterButtons
          selectParameter={selectParameter}
          parameters={[
            { label: "Ville", value: "ville" },
            { label: "Commune", value: "commune" },
            { label: "Quartier", value: "quartier" },
          ]}
        />
        <h1 className="text-center first-letter:capitalize text-2xl font-bold border-b-2 border-slate-300 py-2">
          {selectedParams}
        </h1>
        {selectedParams && fields && (
          <div className="flex w-full space-x-4 justify-center items-center my-4">
            <button
              disabled={!filteredData}
              onClick={() => {
                setShowForm(!showForm);
                setSelected(null);
              }}
              className="text-white w-32 space-x-2 text-3xl flex bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              type="button">
              <CiSettings />
              <p className="text-base">Ajouter</p>
            </button>
          </div>
        )}

        {isLoadingParams ? (
          <div className="flex justify-center items-center">
            <p className="text-2xl font-bold">Chargement...</p>
          </div>
        ) : (
          showTable && (
            <DataTable
            data={(data || []).filter(item => item !== null && item !== undefined)}
            grid={selectedGrid}
            handleShowModal={handleShowModal}
          />
            
          )
        )}
         <div className="w-full flex justify-end mt-4" >
      {showTable &&  <Pagination next={next} prev={prev} />}

      </div>
      </div>
    </Layout>
  );
};

export default GestionAdresses;
